import * as React from "react";
import '../../../public/css/passkey-button.css';

interface PasskeyButtonProps {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    variant?: 'primary' | 'secondary';
    loading?: boolean;
    className?: string;
}

const PasskeyButton: React.FC<PasskeyButtonProps> = ({
    label,
    onClick,
    disabled = false,
    variant = 'primary',
    loading = false,
    className = ''
}) => {
    return (
        <button
            className={`passkey-button passkey-button-${variant} ${className}`}
            onClick={onClick}
            disabled={disabled || loading}
            type="button"
        >
            {loading ? (
                <span className="passkey-button-loading">
                    <span className="spinner"></span>
                    {label}
                </span>
            ) : (
                <>
                    <svg className="passkey-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C9.243 2 7 4.243 7 7c0 2.197 1.428 4.058 3.4 4.731V14H9v2h1.4v2H9v2h6v-2h-1.4v-2H15v-2h-1.4v-2.269C15.572 11.058 17 9.197 17 7c0-2.757-2.243-5-5-5zm0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z" fill="currentColor" />
                    </svg>
                    <span>{label}</span>
                </>
            )}
        </button>
    );
};

export default PasskeyButton;
